"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionCompletedHandler = void 0;
const rxjs_1 = require("rxjs");
const MessageType_1 = require("../message/MessageType");
const InteractionCompleted_1 = require("./InteractionCompleted");
class InteractionCompletedHandler {
    constructor(router, messageClient) {
        this.router = router;
        this.messageClient = messageClient;
        this.interactionCompletedObservable = new rxjs_1.Subject();
        this.router.setHandler(MessageType_1.MessageType.InteractionCompletedRequest, this);
    }
    handle(message) {
        if (this.isInteractionCompletedRequest(message)) {
            const response = {
                messageName: MessageType_1.MessageType.InteractionCompletedResponse,
                payload: {
                    messageID: message.payload.messageID,
                },
            };
            this.messageClient.send(response);
            this.interactionCompletedObservable.next(new InteractionCompleted_1.InteractionCompleted(message.payload.result));
        }
    }
    onInteractionCompleted() {
        return this.interactionCompletedObservable;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isInteractionCompletedRequest(object) {
        return (object.payload instanceof Object &&
            "payload" in object &&
            "messageID" in object.payload &&
            "interaction" in object.payload &&
            "endpoint" in object.payload &&
            "result" in object.payload);
    }
}
exports.InteractionCompletedHandler = InteractionCompletedHandler;
//# sourceMappingURL=InteractionCompletedHandler.js.map